import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  Container,
  CardBody,
  Card,
  Col,
  Row,
} from "reactstrap"

import AllConnectedMaster from "./Connected Master"
import { usePermissionData } from "AppContext"

const ReferenceMaster = () => {
  const { tab_name } = useParams()
  const navigate = useNavigate()
  // , "designation-master"
  const { checkAccess, permissions } = usePermissionData()

  const [tabs, setTabs] = useState([])

  useEffect(() => {
    if (permissions) {
      const newTabs = []
      if (checkAccess(21, "view")) newTabs.push("connected-master")
      setTabs(newTabs) // Update the state with the new array
    }
  }, [permissions])

  useEffect(() => {
    if (!tab_name && tabs.length) {
      navigate(`${app_url}master/reference-master/${tabs[0]}`)
    }
  }, [tab_name, tabs])


  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Reference Master"} />
          <div>
            <Row>
              <Col md={2} className="pe-1">
                <Card>
                  <CardBody className=" rounded custom_side_nav p-2">
                    {tabs.map(tab => {
                      return (
                        <div key={tab} className="mb-2">
                          <Link
                            to={`${app_url}master/reference-master/${tab}`}
                            className={`side_navlink text-capitalize ${tab === tab_name && "bg-white fw-bold"
                              }`}
                          >
                            {tab.replaceAll("-", " ")}
                          </Link>
                        </div>
                      )
                    })}
                  </CardBody>
                </Card>
              </Col>
              <Col md={10}>
                <Card>
                  <CardBody>
                    {tab_name === "connected-master" && (
                      <AllConnectedMaster module_id={21} />
                    )}
                    {/* {
                                            tab_name === tabs[1] &&
                                            <AllDesignationMaster />
                                        } */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default ReferenceMaster
